import React from 'react'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import classnames from 'classnames/bind'
import { Text } from '@adc/ui-adc'
import { formatLocation } from '../../converters/location'
import { checkIsNearbySearch } from '../../util/nearbyCheckbox'
import { getPropertyTotalAmount } from '../../util/asset'
import styles from '../nearbyCheckbox/styles.scss'
const cx = classnames.bind(styles)

const AssetTotals = ({ filters, assets, elmId }) => {
  const renderNearLocation = () => {
    const { city, zip, county, useNearbySearch } = filters
    const isNearbySearch = checkIsNearbySearch(city, zip, county)
    const locationOutput = {}
    if (filters.globalSearch === 'y') {
      return ''
    } else if (filters.search) {
      locationOutput.prefix = 'related to '
      locationOutput.value = filters.search
    } else if (
      useNearbySearch === 'y' &&
      isNearbySearch &&
      assets.offset >= assets.nearbyTotal
    ) {
      locationOutput.prefix = 'near '
      locationOutput.value = formatLocation(filters)
    } else {
      const formattedLocation =
        formatLocation(filters) ||
        (filters.locations
          ? (assets.recognizedLocations || [])
              .map(location => location.label)
              .filter(Boolean)
              .join(', ')
          : '')
      locationOutput.prefix = formattedLocation ? 'in ' : ''
      locationOutput.value = formattedLocation
    }
    return (
      <span>
        {locationOutput.prefix}
        {locationOutput.value && (
          <span data-elm-id={`${elmId}_in_location`}>
            {locationOutput.value}
          </span>
        )}
      </span>
    )
  }

  const { total, fetchProgress, nearbyTotal = 0, offset } = assets
  const nearLocation = renderNearLocation()
  const nearbyPropertyTotal =
    nearbyTotal > offset ? nearbyTotal : total - nearbyTotal
  const propertyTotal = getPropertyTotalAmount(
    { total, nearbyTotal: nearbyPropertyTotal },
    filters.globalSearch
  )

  return (
    <div className={cx('u-ml-3')} data-elm-id={elmId}>
      <div className={cx('asset-totals')}>
        <Text.Header
          as='h1'
          className={cx('description', 'u-mb-1')}
          data-elm-id={`${elmId}_label`}
          color='gray'
          size='huge'
          style={{ marginBottom: 6 }}
        >
          {fetchProgress.loading ? (
            '- Properties'
          ) : (
            <>
              <span data-elm-id={`${elmId}_in_count`}>
                {propertyTotal.toLocaleString('en')}
              </span>
              {` ${pluralize('Property', propertyTotal)} `}
              {nearLocation}
            </>
          )}
        </Text.Header>
      </div>
    </div>
  )
}

AssetTotals.propTypes = {
  filters: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  elmId: PropTypes.string.isRequired,
}

export default AssetTotals
